<div *ngIf="mailboxes">
  <select
    id="ac-selectbox1"
    name="ac-selectbox1"
    class="rs-filled"
    autocompleted=""
    (change)="changeSelectedMailbox($event.target.value)"
  >
    <option *ngFor="let mailbox of mailboxes" [value]="mailbox.mbxId" [selected]="">
      {{ mailbox.displayName }}
    </option>
  </select>
  <label class="rs-form-label" for="ac-selectbox1">{{ 'select.mailbox' | translate }}</label>
</div>
